import api from './api';

export default {
  getAchievements() {
    return api.get('/achievements/api/v1/achievements');
  },
};
